import { LOGO_URL, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, INSTAGRAM_URL, INSTAGRAM_HANDLE, ADDRESS } from "@/constants/site";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#141010] border-t border-[#D4AF37]/20 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="The Build and Design logo" className="h-14 w-14 object-cover rounded-sm" />
            <div className="leading-tight">
              <span className="font-heading text-xl text-[#D4AF37] block">The Build and Design</span>
              <span className="text-[10px] tracking-[0.3em] text-[#B8A99A] uppercase">{t.brand.tagline}</span>
            </div>
          </div>
          <p className="mt-6 text-[#B8A99A] text-sm leading-relaxed max-w-xs">
            {t.footer.blurb}
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-6">{t.footer.services}</h4>
          <ul className="space-y-3 text-sm text-[#B8A99A]">
            {t.services.items.map((s) => (
              <li key={s.title}>{s.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-6">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm text-[#B8A99A]">
            <li>
              <a href={PHONE_TEL} className="hover:text-[#D4AF37] transition-colors" data-testid="footer-phone-link">{PHONE_DISPLAY}</a>
            </li>
            <li>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-whatsapp-link">
                {t.footer.whatsapp}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-instagram-link">
                Instagram {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li className="max-w-xs" data-testid="footer-address">{ADDRESS}</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-14 pt-8 border-t border-[#D4AF37]/10 text-center text-xs text-[#B8A99A]/60 tracking-widest uppercase">
        {t.footer.bottom}
      </div>
    </footer>
  );
};
